module.exports = __webpack_public_path__ + "static/img/bg-14.3c20135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-14.png
// module id = ALhg
// module chunks = 0